//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
var myChart;
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    tableName: {
      type: String,
      default: '水质分布'
    },
    top: {
      type: String,
      default: '-36px'
    },
    left: {
      type: String,
      default: '-130px'
    }
  },
  data: function data() {
    return {
      chart: 'chart9',
      timer: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    initBarChart: function initBarChart(datas) {
      var subtext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var angle = 0; //角度，用来做简单的动画效果的

      var value = (datas * 100).toFixed(2);
      var option = {
        // backgroundColor:"#061740",
        title: {
          text: '{a|' + value + '}{c|%}',
          x: 'center',
          y: 'center',
          subtext: subtext ? subtext : '',
          subtextStyle: {
            lineHeight: -100
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 28,
                color: '#29EEF3'
              },
              c: {
                fontSize: 18,
                color: '#ffffff' // padding: [5,0]

              }
            }
          }
        },
        series: [{
          name: 'ring5',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.6,
                startAngle: (0 + angle) * Math.PI / 180,
                endAngle: (90 + angle) * Math.PI / 180
              },
              style: {
                stroke: '#0CD3DB',
                fill: 'transparent',
                lineWidth: 1.5
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: 'ring5',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.6,
                startAngle: (180 + angle) * Math.PI / 180,
                endAngle: (270 + angle) * Math.PI / 180
              },
              style: {
                stroke: '#0CD3DB',
                fill: 'transparent',
                lineWidth: 1.5
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: 'ring5',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65,
                startAngle: (270 + -angle) * Math.PI / 180,
                endAngle: (40 + -angle) * Math.PI / 180
              },
              style: {
                stroke: '#0CD3DB',
                fill: 'transparent',
                lineWidth: 1.5
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: 'ring5',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            return {
              type: 'arc',
              shape: {
                cx: api.getWidth() / 2,
                cy: api.getHeight() / 2,
                r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65,
                startAngle: (90 + -angle) * Math.PI / 180,
                endAngle: (220 + -angle) * Math.PI / 180
              },
              style: {
                stroke: '#0CD3DB',
                fill: 'transparent',
                lineWidth: 1.5
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: 'ring5',
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            var x0 = api.getWidth() / 2;
            var y0 = api.getHeight() / 2;
            var r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65;
            var point = getCirlPoint(x0, y0, r, 90 + -angle);
            return {
              type: 'circle',
              shape: {
                cx: point.x,
                cy: point.y,
                r: 4
              },
              style: {
                stroke: '#0CD3DB',
                //粉
                fill: '#0CD3DB'
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: 'ring5',
          //绿点
          type: 'custom',
          coordinateSystem: 'none',
          renderItem: function renderItem(params, api) {
            var x0 = api.getWidth() / 2;
            var y0 = api.getHeight() / 2;
            var r = Math.min(api.getWidth(), api.getHeight()) / 2 * 0.65;
            var point = getCirlPoint(x0, y0, r, 270 + -angle);
            return {
              type: 'circle',
              shape: {
                cx: point.x,
                cy: point.y,
                r: 4
              },
              style: {
                stroke: '#0CD3DB',
                //绿
                fill: '#0CD3DB'
              },
              silent: true
            };
          },
          data: [0]
        }, {
          name: '吃猪肉频率',
          type: 'pie',
          radius: ['58%', '45%'],
          silent: true,
          clockwise: true,
          startAngle: 90,
          z: 0,
          zlevel: 0,
          label: {
            normal: {
              position: 'center'
            }
          },
          data: [{
            value: value,
            name: '',
            itemStyle: {
              normal: {
                color: {
                  // 完成的圆环的颜色
                  colorStops: [{
                    offset: 0,
                    color: '#4FADFD' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: '#28E8FA' // 100% 处的颜色

                  }]
                }
              }
            }
          }, {
            value: 100 - value,
            name: '',
            label: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: '#173164'
              }
            }
          }]
        }, {
          name: '',
          type: 'gauge',
          radius: '58%',
          center: ['50%', '50%'],
          startAngle: 0,
          endAngle: 359.9,
          splitNumber: 8,
          hoverAnimation: true,
          axisTick: {
            show: false
          },
          splitLine: {
            length: 60,
            lineStyle: {
              width: 5,
              color: '#061740'
            }
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: false
          },
          axisLine: {
            lineStyle: {
              opacity: 0
            }
          },
          detail: {
            show: false
          },
          data: [{
            value: 0,
            name: ''
          }]
        }]
      }; //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)

      function getCirlPoint(x0, y0, r, angle) {
        var x1 = x0 + r * Math.cos(angle * Math.PI / 180);
        var y1 = y0 + r * Math.sin(angle * Math.PI / 180);
        return {
          x: x1,
          y: y1
        };
      }

      function draw() {
        angle = angle + 3;
        myChart.setOption(option, true); //window.requestAnimationFrame(draw);
      }

      this.timer = setInterval(function () {
        //用setInterval做动画感觉有问题
        draw();
      }, 100);
      var chart = this.$refs[this.chart];
      myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};